export default __webpack_public_path__ + "static/media/chatBubble-working.1a56fba3.svg";